import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class GridStatusService {
    readonly onGridReload = new Subject<void>();

    reloadGrid(): void {
        this.onGridReload.next();
    }
}
